import { useState } from 'react';
import FilterDropdown, { FilterOption } from '../../components/custom-input/FilterDropdown';
import ResetPassword from './ResetPassword';
import PaymentDiscrepancies from './PaymentDiscrepancies';
import BillingManagement from './BillingManagement';
import { PAGE_HEADER_CONSTANTS, PASSWORDS_CONSTANTS, QUICKBOOKS_CONSTANTS } from '../../constants/common';
import './adminSettings.scss';

const AdminSettings = () => {
  const [activeTab, setActiveTab] = useState(0);

  const mobileTabOptions: FilterOption<number>[] = [
    { name: PASSWORDS_CONSTANTS.RESET_PASSWORD, value: 0 },
    { name: QUICKBOOKS_CONSTANTS.QUICKBOOKS, value: 1 },
    { name: PAGE_HEADER_CONSTANTS.BILLING_MANAGEMENT, value: 2 },
  ];

  const selectedMobileTab = mobileTabOptions.find(option => option.value === activeTab) ?? mobileTabOptions[0];

  return (
    <div className="admin-settings-page">
      <div className="admin-settings card">
        <div className="admin-settings__header">
          <h2>{PAGE_HEADER_CONSTANTS.ADMIN_SETTINGS}</h2>

          {/* Desktop view */}
          <ul className="admin-settings__tabs admin-settings__tabs--desktop">
            <li className={activeTab === 0 ? 'active' : ''} onClick={() => setActiveTab(0)}>
              <div className="reset-password">{PASSWORDS_CONSTANTS.RESET_PASSWORD}</div>
            </li>
            <li className={activeTab === 1 ? 'active' : ''} onClick={() => setActiveTab(1)}>
              <div className="quick-books">{QUICKBOOKS_CONSTANTS.QUICKBOOKS}</div>
            </li>
            <li className={activeTab === 2 ? 'active' : ''} onClick={() => setActiveTab(2)}>
              <div className="billing-management">{PAGE_HEADER_CONSTANTS.BILLING_MANAGEMENT}</div>
            </li>
          </ul>
        </div>

        {/* Mobile view */}
        <div className="admin-settings__mobile-nav">
          <FilterDropdown
            options={mobileTabOptions}
            value={selectedMobileTab}
            onChange={option => setActiveTab(Number(option.value))}
            placeholder="Select section"
            showSearch={false}
            highlightSelectedOption={true}
          />
        </div>

        <div className="admin-settings__body">
          {activeTab === 0 && <ResetPassword />}
          {activeTab === 1 && <PaymentDiscrepancies />}
          {activeTab === 2 && <BillingManagement />}
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
